import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name.' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name.' }
      ]
    },
    clientname: {
      validations: []
    },
    addressline1: {
      validations: [
        { type: 'required', message: 'Please provide an address.' }
      ]
    },
    city: {
      validations: [
        { type: 'required', message: 'Please provide a city.' }
      ]
    },
    state: {
      validations: [
        { type: 'required', message: 'Please provide a state.' }
      ]
    },
    postal: {
      validations: [
        { type: 'required', message: 'Please provide a zip code.' }
      ]
    },
    telnumber: {
      validations: [
        { type: 'required', message: 'Please provide a phone number.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number format that does not include spaces.' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email address.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
    },
    category: {
      validations: [
        { type: 'required', message: 'Please provide an event type.' }
      ]
    },
    accountextra5: {
      validations: [
        { type: 'required', message: 'Please complete required field.' }
      ]
    },
    accountextra6: {
      validations: [
        { type: 'required', message: 'Please provide a guest count.' }
      ]
    },
    accountextra9: {
      validations: [
        { type: 'required', message: 'Please provide an event budget.' }
      ]
    },
    accountextra7: {
      validations: [
        { type: 'required', message: 'Please provide a venue or location.' }
      ]
    },
    accountextra3: {
      validations: [
        { type: 'required', message: 'Please complete required field.' }
      ]
    },
    notes: {
      validations: []
    },
    accountextra4: {
      validations: []
    },
    accountextra8: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'lastName'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Company Name:',
            mapping: 'clientname',
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Address:*',
            mapping: 'addressline1',
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'City:*',
            mapping: 'city',
          },
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'State:*',
            options: [
              { label: 'AL', value: 'AL' },
              { label: 'AK', value: 'AK' },
              { label: 'AZ', value: 'AZ' },
              { label: 'AR', value: 'AR' },
              { label: 'CA', value: 'CA' },
              { label: 'CO', value: 'CO' },
              { label: 'CT', value: 'CT' },
              { label: 'DE', value: 'DE' },
              { label: 'DC', value: 'DC' },
              { label: 'FL', value: 'FL' },
              { label: 'GA', value: 'GA' },
              { label: 'HI', value: 'HI' },
              { label: 'ID', value: 'ID' },
              { label: 'IL', value: 'IL' },
              { label: 'IN', value: 'IN' },
              { label: 'IA', value: 'IA' },
              { label: 'KS', value: 'KS' },
              { label: 'KY', value: 'KY' },
              { label: 'LA', value: 'LA' },
              { label: 'ME', value: 'ME' },
              { label: 'MD', value: 'MD' },
              { label: 'MA', value: 'MA' },
              { label: 'MI', value: 'MI' },
              { label: 'MN', value: 'MN' },
              { label: 'MS', value: 'MS' },
              { label: 'MO', value: 'MO' },
              { label: 'MT', value: 'MT' },
              { label: 'NE', value: 'NE' },
              { label: 'NV', value: 'NV' },
              { label: 'NH', value: 'NH' },
              { label: 'NJ', value: 'NJ' },
              { label: 'NM', value: 'NM' },
              { label: 'NY', value: 'NY' },
              { label: 'NC', value: 'NC' },
              { label: 'ND', value: 'ND' },
              { label: 'OH', value: 'OH' },
              { label: 'OK', value: 'OK' },
              { label: 'OR', value: 'OR' },
              { label: 'PA', value: 'PA' },
              { label: 'RI', value: 'RI' },
              { label: 'SC', value: 'SC' },
              { label: 'SD', value: 'SD' },
              { label: 'TN', value: 'TN' },
              { label: 'TX', value: 'TX' },
              { label: 'UT', value: 'UT' },
              { label: 'VT', value: 'VT' },
              { label: 'VA', value: 'VA' },
              { label: 'WA', value: 'WA' },
              { label: 'WV', value: 'WV' },
              { label: 'WI', value: 'WI' },
              { label: 'WY', value: 'WY' }
            ],
            mapping: 'state',
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Postal:*',
            mapping: 'postal',
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number:*',
            mapping: 'telnumber',
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email Address:*',
            mapping: 'email',
          },
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Event Type:*',
            options: [
              { label: 'Wedding', value: 'Wedding'},
              { label: 'Social', value: 'Social'},
              { label: 'Corporate', value: 'Corporate'},
              { label: 'Other', value: 'Other'}
            ],
            mapping: 'category'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date:*',
            mapping: 'accountextra5',
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Guest Count:*',
            mapping: 'accountextra6',
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Budget:*',
            mapping: 'accountextra9',
          },
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Venue/Location:*',
            options: [
              { label: 'Private Residence', value: 'Private Residence'},
              { label: 'Corporate Office', value: 'Corporate Office'},
              { label: 'Forest Preserve', value: 'Forest Preserve'},
              { label: 'Residential Property Building', value: 'Residential Property Building'},
              { label: 'Alter Brewing', value: 'Alter Brewing'},
              { label: 'Amazing Space', value: 'Amazing Space'},
              { label: 'Barrington White House', value: 'Barrington White House'},
              { label: 'Bluestem Farms', value: 'Bluestem Farms'},
              { label: 'Blumen Garden', value: 'Blumen Garden'},
              { label: 'Bridge 410', value: 'Bridge 410'},
              { label: 'Bridgeport Art Center - Sculpture Garden', value: 'Bridgeport Art Center - Sculpture Garden'},
              { label: 'Bridgeport Art Center - Skyline Loft', value: 'Bridgeport Art Center - Skyline Loft'},
              { label: 'Buffalo Creek Brewing', value: 'Buffalo Creek Brewing'},
              { label: 'Catalyst Ranch', value: 'Catalyst Ranch'},
              { label: 'Cedar Fox', value: 'Cedar Fox'},
              { label: 'Cheney Mansion', value: 'Cheney Mansion'},
              { label: 'Chicago Cultural Center', value: 'Chicago Cultural Center'},
              { label: 'Colvin House', value: 'Colvin House'},
              { label: 'Cosley Zoo', value: 'Cosley Zoo'},
              { label: 'Courthouse Square', value: 'Courthouse Square'},
              { label: 'Creek Bend Nature Center', value: 'Creek Bend Nature Center'},
              { label: 'Danada House', value: 'Danada House'},
              { label: 'Elmhurst Art Museum', value: 'Elmhurst Art Museum'},
              { label: 'Fairlie', value: 'Fairlie'},
              { label: 'Firehouse Chicago', value: 'Firehouse Chicago'},
              { label: 'Floating World Gallery', value: 'Floating World Gallery'},
              { label: 'Gather', value: 'Gather'},
              { label: 'Gene Siskel Film Center', value: 'Gene Siskel Film Center'},
              { label: 'Goodman Theatre', value: 'Goodman Theatre'},
              { label: 'Goose Island Barrel House', value: 'Goose Island Barrel House'},
              { label: 'Great Central Brewing', value: 'Great Central Brewing'},
              { label: 'Greenhouse Loft', value: 'Greenhouse Loft'},
              { label: 'Highland Loft', value: 'Highland Loft'},
              { label: 'Hoosier Grove Barn', value: 'Hoosier Grove Barn'},
              { label: 'International Museum of Surgical Science', value: 'International Museum of Surgical Science'},
              { label: 'Kenilworth Club', value: 'Kenilworth Club'},
              { label: 'Lakes at Lacey', value: 'Lakes at Lacey'},
              { label: 'Lakeview Rooms', value: 'Lakeview Rooms'},
              { label: 'Loft 21', value: 'Loft 21'},
              { label: 'Loft on Lake', value: 'Loft on Lake'},
              { label: 'Mayslake Peabody', value: 'Mayslake Peabody'},
              { label: 'Motor Row Brewery', value: 'Motor Row Brewery'},
              { label: 'Ovation', value: 'Ovation'},
              { label: 'Pete’s Dueling Piano Bar', value: 'Pete’s Dueling Piano Bar'},
              { label: 'Pete’s Tiki Tiki Bar', value: 'Pete’s Tiki Tiki Bar'},
              { label: 'Pleasant Home', value: 'Pleasant Home'},
              { label: 'Providence Vineyard', value: 'Providence Vineyard'},
              { label: 'Revelry675', value: 'Revelry675'},
              { label: 'Rockwell on The River', value: 'Rockwell on The River'},
              { label: 'Room 1520', value: 'Room 1520'},
              { label: 'Salvage One', value: 'Salvage One'},
              { label: 'Sarabande', value: 'Sarabande'},
              { label: 'Society 57', value: 'Society 57'},
              { label: 'St. Ignatius', value: 'St. Ignatius'},
              { label: 'Stan Mansion', value: 'Stan Mansion'},
              { label: 'The Arbory', value: 'The Arbory'},
              { label: 'The Bridge – Lemont', value: 'The Bridge – Lemont'},
              { label: 'The Brix', value: 'The Brix'},
              { label: 'The Crawford', value: 'The Crawford'},
              { label: 'The District', value: 'The District'},
              { label: 'The Farmhouse – Plainfield', value: 'The Farmhouse – Plainfield'},
              { label: 'The Grove at Redfield Estate', value: 'The Grove at Redfield Estate'},
              { label: 'The Haight', value: 'The Haight'},
              { label: 'The Loft at Ethereal', value: 'The Loft at Ethereal'},
              { label: 'The Lytle House', value: 'The Lytle House'},
              { label: 'The Old Post Office', value: 'The Old Post Office'},
              { label: 'The Penthouse Hyde Park', value: 'The Penthouse Hyde Park'},
              { label: 'The Standard on State', value: 'The Standard on State'},
              { label: 'University of Chicago', value: 'University of Chicago'},
              { label: 'Venue Overdrive', value: 'Venue Overdrive'},
              { label: 'Venue West', value: 'Venue West'},
              { label: 'Wagner Farms', value: 'Wagner Farms'},
              { label: 'Wandering Tree Estates', value: 'Wandering Tree Estates'},
              { label: 'Warehouse 109', value: 'Warehouse 109'},
              { label: 'White Stone Events', value: 'White Stone Events'},
              { label: 'Wilder Mansion', value: 'Wilder Mansion'},
              { label: 'Wildman BT', value: 'Wildman BT'},
              { label: 'Other', value: 'Other'}
            ],
            mapping: 'accountextra7',
          },
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'How Did You Hear About Us?:*',
            options: [
              { label: 'TV Commercial', value: 'TV Commercial'},
              { label: 'Friend/Family Referral', value: 'Friend/Family Referral'},
              { label: 'Networking Event', value: 'Networking Event'},
              { label: 'Online Ad', value: 'Online Ad'},
              { label: 'Online Search Engine', value: 'Online Search Engine'},
              { label: 'Open House/Trade Show', value: 'Open House/Trade Show'},
              { label: 'Planner Referral', value: 'Planner Referral'},
              { label: 'Received a Call/Email from SBR', value: 'Received a Call/Email from SBR'},
              { label: 'Saw SBR Vehicle/Building', value: 'Saw SBR Vehicle/Building'},
              { label: 'SBR Employee Referral', value: 'SBR Employee Referral'},
              { label: 'SBR Restaurant', value: 'SBR Restaurant'},
              { label: 'Social Media', value: 'Social Media'},
              { label: 'The Knot/Wedding Wire', value: 'The Knot/Wedding Wire'},
              { label: 'Used SBR in the Past', value: 'Used SBR in the Past'},
              { label: 'Vendor Referral', value: 'Vendor Referral'},
              { label: 'Venue Referral', value: 'Venue Referral'},
            ],
            mapping: 'accountextra3',
          },
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Message:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SUBMIT'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Sweet Baby Ray\'s Contact Form',
    formId: '286',
    clientKey: '7F32380D-81FF-4223-A218-5E337FCD6EB1',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: 'https://www.sbrevents.com/thank-you-page',
    submissionText: '',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
